import { render, staticRenderFns } from "./YourIngredients.vue?vue&type=template&id=417f2794&scoped=true&"
import script from "./YourIngredients.vue?vue&type=script&lang=js&"
export * from "./YourIngredients.vue?vue&type=script&lang=js&"
import style0 from "./YourIngredients.vue?vue&type=style&index=0&id=417f2794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f2794",
  null
  
)

export default component.exports